// React
import { memo } from "react";

// UI
import { Alert } from "ui/components/Alert";

import { InvoiceIncomingFileIntakeProps } from "./types";

/**
 * Što treba provjeriti na pročitanom računu i koje datoteke nismo primili. Napredak kroz red javlja
 * obavijest u kutu, a radnje nad redom stoje u podnožju — ovdje ostaje samo ono uz što korisnik
 * mora nešto poduzeti, pa to i mora stajati nad obrascem dok radi.
 */
const InvoiceIncomingFileIntake: React.FC<InvoiceIncomingFileIntakeProps> = (props) => {
  const { rejected, warnings } = props;

  return (
    <div className="mb-4 flex flex-col gap-2">
      {warnings.map(warning => (
        <Alert key={warning} variant="warning" message={warning} />
      ))}

      {rejected.length > 0 && (
        <Alert
          variant="danger"
          title="Neke datoteke nisu primljene"
          message={rejected.map(item => `${item.fileName}: ${item.reason}`).join(" · ")}
        />
      )}
    </div>
  );
};

export default memo(InvoiceIncomingFileIntake);
